"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Recipe (Menu & Recipe POS Integration)
__exportStar(require("./recipe.schema"), exports);
// In-app issue reporter (support tickets)
__exportStar(require("./app-issue.schema"), exports);
// User notification bell (unified support center, 2026-08-26)
__exportStar(require("./user-notification.schema"), exports);
// AgenticPOS
__exportStar(require("./agenticpos"), exports);
// Platform-wide AI registry (product-neutral, 2026-09-01)
__exportStar(require("./platform"), exports);
//# sourceMappingURL=index.js.map